import { z } from 'zod';
import { BaseResponseSchema, } from './primitives.js';
import { EfemGatewayRegistryTemplateDataSchema, EfemGatewayOverridesSchema, } from '../efem-gateway-config-schemas.js';
// ── Site Gateway Assignment ───────────────────────────────────────────────────
// Tracks which location gateway (edge PC) is assigned to a given site.
// The serialNumber is the device's hardware serial; thingName is the AWS IoT Thing name
// created during Fleet Provisioning.
export const SiteGatewaySchema = z.object({
    serialNumber: z.string(),
    thingName: z.string().nullable(),
    /** When this gateway was linked to the site (distinct from tenant `allocatedAt`). */
    siteAssignedAt: z.string().datetime().nullable(),
});
export const SiteGatewayListResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        siteId: z.string(),
        gateways: z.array(SiteGatewaySchema),
    }),
});
export const SiteGatewayParamsSchema = z.object({
    siteId: z.string().min(1).max(128),
    serialNumber: z.string().min(1).max(128),
});
export const SiteGatewayResponseSchema = BaseResponseSchema.extend({
    data: SiteGatewaySchema,
});
// ── EFEM gateway S3 config (provider) — see efem-gateway-config-schemas.ts ───
export { EfemGatewayConfigOverridesBodySchema, EfemGatewayConfigPushBodySchema, EfemGatewayOverridesSchema, EfemMergedGatewayConfigSchema, EfemOrchestratorConfigSchema, EfemBarcodeScannerConfigSchema, EfemHandheldBarcodeScannerConfigSchema, EfemWaferIdCameraConfigSchema, EfemAdapterConfigSchema, EfemAdapterKeyFieldSchema, EfemGatewayManifestSchema, ApplyEfemGatewayConfigPayloadSchema, EfemGatewayRegistryTemplateDataSchema, } from '../efem-gateway-config-schemas.js';
export { EfemAdapterAssignmentSchema, PutEfemAdapterAssignmentBodySchema, EfemAdapterRegistryListResponseSchema, EfemAdapterAssignmentResponseSchema, } from '../efem-adapter-assignment-schemas.js';
export { LocationAdapterAssignmentSchema, PutLocationAdapterAssignmentBodySchema, LocationAdapterRegistryEntrySummarySchema, LocationAdapterRegistryListResponseSchema, LocationAdapterAssignmentResponseSchema, } from '../location-adapter-assignment-schemas.js';
export const EfemGatewayConfigVersionParamSchema = z.object({
    serialNumber: z.string().min(1).max(64),
    version: z.string().min(1).max(64),
});
export const EfemGatewayConfigPreviewResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        merged: z.record(z.unknown()),
        reloadPlan: z.array(z.string()),
        warnings: z.array(z.string()),
        adapterSwap: z.object({
            previousEfemAdapterKey: z.string().nullable(),
            newEfemAdapterKey: z.string(),
        }).nullable(),
    }),
});
export const EfemGatewayRegistryTemplateResponseSchema = BaseResponseSchema.extend({
    data: EfemGatewayRegistryTemplateDataSchema,
});
export const EfemGatewayConfigPushResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        configVersion: z.string(),
        manifestKey: z.string(),
        status: z.enum(['s3_uploaded', 'mqtt_sent', 's3_uploaded_mqtt_failed', 'applied', 'apply_failed', 'apply_timeout', 'superseded']),
        mqttRequestId: z.string().uuid().optional(),
        warnings: z.array(z.string()),
        reloadPlan: z.array(z.string()),
        presignedUrlExpiresAt: z.string().datetime(),
        pushedAt: z.string().datetime(),
    }),
});
export const EfemGatewayOverridesResponseSchema = BaseResponseSchema.extend({
    data: EfemGatewayOverridesSchema,
});
export const EfemGatewayConfigHistoryResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        gatewaySerialNumber: z.string(),
        items: z.array(z.object({
            configVersion: z.string(),
            status: z.string(),
            pushedAt: z.string().datetime(),
            pushedBy: z.object({ userId: z.string(), email: z.string() }).optional(),
            mqttSentAt: z.string().datetime().optional(),
            mqttAckAt: z.string().datetime().optional(),
            errorMessage: z.string().optional(),
            pushMetadata: z.record(z.unknown()).optional(),
            edgeResponse: z.record(z.unknown()).optional(),
        })),
    }),
});
//# sourceMappingURL=site-gateways.schemas.js.map